export function operacaoOperStatusTerminaisInRequest(params = {}) {
  return {
    type: '@operacaooperstatusterminais/OPERSTATUSTERMINAIS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoOperStatusTerminais(term_identificacao) {
  return {
    type: '@operacaooperstatusterminais/FIND_OPERSTATUSTERMINAIS',
    payload: { term_identificacao },
  };
}

export function failedRequest() {
  return {
    type: '@operacaooperstatusterminais/FAILED_REQUEST',
  };
}

export function deleteOperacaoOperStatusTerminais(term_identificacao, params) {
  return {
    type: '@operacaooperstatusterminais/DELETE_OPERSTATUSTERMINAIS',
    payload: { term_identificacao, params },
  };
}

export function updateOperacaoOperStatusTerminais(operacaooperstatusterminais, params) {
  return {
    type: '@operacaooperstatusterminais/UPDATE_OPERSTATUSTERMINAIS',
    payload: { operacaooperstatusterminais, params },
  };
}

export function storeOperacaoOperStatusTerminais(operacaooperstatusterminais, params) {
  return {
    type: '@operacaooperstatusterminais/STORE_OPERSTATUSTERMINAIS',
    payload: { operacaooperstatusterminais, params },
  };
}

export function successInRequest(
  operacaooperstatusterminais,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaooperstatusterminais/SUCCESS_IN_REQUEST',
    payload: { operacaooperstatusterminais, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaooperstatusterminais) {
  return {
    type: '@operacaooperstatusterminais/SUCCESS_REQUEST',
    payload: { operacaooperstatusterminais },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaooperstatusterminais/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaooperstatusterminais/RECORD_FILTERING',
    payload: { params },
  };
}

export function refresh() {
  return {
    type: '@operacaooperstatusterminais/REFRESH'
  }
}